var render = function render(){var _vm=this,_c=_vm._self._c;return _c('curation-write-component',{attrs:{"curation-type":'curationWrite',"itemKey":_vm.itemKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }